import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { BetslipDigitalTrackingService } from './services/betslip-digital-tracking.service';
import { BetslipLaunchDarklyTrackingService } from './services/betslip-launch-darkly-tracking.service';
import BetslipDigitalTrackingEffects from './state/betslip-digital-tracking.effects';
import BetslipLinearTrackingEffects from './state/betslip-linear-tracking.effects';

@NgModule({
    imports: [EffectsModule.forFeature([BetslipDigitalTrackingEffects]), EffectsModule.forFeature([BetslipLinearTrackingEffects])],
    declarations: [],
    exports: [],
    providers: [BetslipDigitalTrackingService, BetslipLaunchDarklyTrackingService],
})
export default class BetslipDigitalTrackingModule {}
